module.exports = __webpack_public_path__ + "static/media/easy2_branco.27c99410.png";